import { configureStore } from "@reduxjs/toolkit";
import { logger } from "redux-logger";
import infoReducer from "./slices/infoSlice";
import loadingReducer from "./slices/loadingSlice";
import aboutEditReducer from "./slices/profile/aboutEditSlice";
import addSkillReducer from "./slices/profile/addSkillSlice";
import discoverReducer from "./slices/profile/discoverSlice";
import manageProjectsReducer from "./slices/profile/manageProjectsSlice";
import profileCompleteReducer from "./slices/profile/profileCompleteSlice";
import profileImageReducer from "./slices/profile/profileImageSlice";
import projectCoverImageReducer from "./slices/profile/projectCoverImageSlice";
import projectDetailsReducer from "./slices/profile/projectDetailsSlice";
import projectFiltersSlice from "./slices/profile/projectFiltersSlice";
import publicUserReducer from "./slices/profile/publicUserSlice";
import rolesReducer from "./slices/profile/rolesSlice";
import searchReducer from "./slices/profile/searchSlice";
import settingsReducer from "./slices/profile/settingsSlice";
import shoutoutsReducer from "./slices/profile/shoutoutsSlice";
import skillImageReducer from "./slices/profile/skillImageSlice";
import skillReducer from "./slices/profile/skillSlice";
import registerationReducer from "./slices/registerationSlice";
import userReducer from "./slices/userSlice";

const store = configureStore({
	reducer: {
		// theme: themeReducer,
		isLoading: loadingReducer,
		user: userReducer,
		publicUser: publicUserReducer,
		// signup: signupReducer, // there is a custom hook
		registeration: registerationReducer,
		profileImage: profileImageReducer,
		aboutEdit: aboutEditReducer,
		skillImage: skillImageReducer,
		addSkill: addSkillReducer,
		skill: skillReducer,
		manageProjects: manageProjectsReducer, // There is a custom hook
		projectDetails: projectDetailsReducer,
		projectCoverImage: projectCoverImageReducer,
		projectFilters: projectFiltersSlice, // There is a custom hook with effects
		discover: discoverReducer, // There is a custom hook with effects
		search: searchReducer,
		shoutouts: shoutoutsReducer,
		profileComplete: profileCompleteReducer, // There is a custom hook with effects
		settings: settingsReducer, // There is a custom hook with effects
		info: infoReducer,
		roles: rolesReducer,
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});

export default store;
